import { useContext, useEffect } from "react";
import { ToolContext } from "../../../../context/ToolContext";
import { JoyrideWrapper } from "../JoyrideWrapper";

export const CheckoutWalkthrough = ({ pathname, end, start}) => {

    const {personalization_state, product_state} = useContext(ToolContext)
    const {walkthrough} = personalization_state
    const {checkOut} = product_state

    const startTour = () =>{
        walkthrough.set((prev) => ({...prev, checkout:true}))
    }

    useEffect(() => {
        if (checkOut.data.open) {
            start("home", "checkout", startTour)
        }
        //eslint-disable-next-line
    }, [checkOut.data]);

    const endTour = ()=>{
        walkthrough.set((prev) => ({...prev, checkout:false}))
    }

    const steps =[
            {
                content: "Receive order details",
                placement: "right",
                target: "#walkthrough-checkout-step-0",
                disableBeacon: true
            },
            {
                content: "Receive payment before tapping Pay",
                placement: "right",
                target: "#walkthrough-checkout-step-2",
                disableBeacon: true
            },
        ]

    return (
            <JoyrideWrapper 
                run={walkthrough.data.checkout && window.location.pathname === pathname && checkOut.data.open} 
                steps={steps} 
                setter={endTour} 
                end={end}
                p_name="checkout" 
                featureName="home"
            />
        );
}
